<template>
    <div class="h-100">
        <div class="d-flex justify-content-between ">
          <div class="d-flex gap-2">
              <img v-if="type === types.BIRTHDAY" class="border-radius-20 cover top" height="70" width="70" :src="event.image ? event.image.sizes.sm : '/img/avatar.png'" :alt="event.name"/>
              <div>
                  <h3 :class="color"> <i v-if="type !== types.BIRTHDAY" class="icon fi " :class="[icon, color]"></i> {{  title }}</h3>
                  <p>{{ time }}</p>
              </div>
          </div>
          <button class="btn btn-circle" @click="closeModal"><i class="fi fi-rr-x"></i></button>
        </div>
        <div v-if="event.type === types.EVENT">
            <plan-action-buttons
                v-on:status-change="onStatusChange($event)"
                :plan="event"/>
        </div>

        <div v-if="type === types.BIRTHDAY" class="d-flex justify-content-center">
            <div class="text-center">
                <i class="icon fi fs-1 op-0-5" :class="[icon, color]"></i>
                <p class="mt-2">{{event.name}} {{event.surname}}</p>
            </div>
        </div>

        <div class="mt-4" v-if="event.description">
            <h5>{{trans('general.component.calendar.description')}}:</h5>
            <div class="text-wrap">
                {{event.description}}
            </div>
        </div>

        <div class="mt-4" v-if="type === types.EVENT || type === types.APPOINTMENT">
            <h5>{{trans('general.component.calendar.members')}}: </h5>
            <div class="d-flex flex-wrap gap-2">
                <div class="card  px-3 py-2" v-for="member in listOfMembers"
                     :class="{'bg-light-green text-dark-green': member.pivot.approved_at, 'bg-light-red text-danger': member.pivot.rejected_at}">
                    {{ member.pivot.approved_at ? '✅' : (member.pivot.rejected_at ? '❌' : '') }} {{ member.name }}
                    {{ member.surname }}
                </div>
            </div>
            <div class="text-center">
                <button class="btn btn-sm btn-link mt-1 align-self-center" v-if="listOfMembers.length < members.length && !showAllMembers" @click="showAllMembers = true">
                    {{trans('general.defaults.show_all')}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {CALENDAR_TYPES} from "../../../services/Defaults";
import ROLES from "../../../services/RoleService";
import moment from "moment/moment";
import PlanActionButtons from "../../../theme/atoms/PlanActionButtons"

export default {
    name: "EventView",
    props: {
        date: {
            type: Object | String,
            required: false
        },
        role: {
            type: String,
            required: true
        },
        event: {
            type: Object,
            required: true
        }
    },
    components: {
        PlanActionButtons
    },
    data() {
        return {
            types: CALENDAR_TYPES,
            roles: ROLES,
            members: [],
            model: this.event,
            showAllMembers: false
        }
    },
    computed: {
        type() {
            return this.event.birthday ? CALENDAR_TYPES.BIRTHDAY : this.event.type
        },
        title() {
            return this.type === CALENDAR_TYPES.BIRTHDAY
                ? trans('general.component.calendar.child_birthday', {attribute: this.event.name})
                : this.event.title
        },
        icon() {
            const icons = {birthday: 'fi-rr-cake-birthday', event: 'fi-rr-calendar-clock', appointment: 'fi-rr-clock'}

            return icons[this.type];
        },
        color() {
            const icons = {birthday: 'text-blue', event: 'text-pink', appointment: 'text-secondary'};

            return icons[this.type];
        },
        time() {
            return this.type === CALENDAR_TYPES.BIRTHDAY
                ? moment(this.event.birthday).format('DD-MM-YYYY') + ', ' + moment(this.date).diff(moment(this.event.birthday), 'years') + ' ' + trans('general.time_ago.years')
                :(
                    this.event.type === 'event' ?
                        (this.event.end ? moment(this.event.start).format('LLLL') + '-' + moment(this.event.end).format('LT') : moment(this.event.start).format('dddd, MMMM D, YYYY') )
                        :
                        moment(this.event.start).format('LLLL') + (this.event.end ? '-' + moment(this.event.end).format('LT') : '')
                )
        },
        listOfMembers() {
            return !this.showAllMembers && this.members.length > 6 ? this.members.slice(0, 6) : this.members;
        }
    },
    methods: {
        onStatusChange($event) {
            this.members = this.members.map(member => {
                if (member.id === this.event.user_status.user_id) {
                    member.pivot = $event
                }
                return member;
            })
        },
        closeModal: function () {
            this.$FModal.hide();
        },
    },
    mounted() {
        this.members = this.event.members;
    }
}
</script>
